import { render, staticRenderFns } from "./EditAddress.vue?vue&type=template&id=1491e765"
import script from "./EditAddress.vue?vue&type=script&lang=js"
export * from "./EditAddress.vue?vue&type=script&lang=js"
import style0 from "./EditAddress.vue?vue&type=style&index=0&id=1491e765&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports